import { render, staticRenderFns } from "./vodSetting.vue?vue&type=template&id=37c5070c&scoped=true&"
import script from "./vodSetting.vue?vue&type=script&lang=js&"
export * from "./vodSetting.vue?vue&type=script&lang=js&"
import style0 from "./vodSetting.vue?vue&type=style&index=0&id=37c5070c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5070c",
  null
  
)

export default component.exports